import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { connect, useSelector } from 'react-redux';
import classnames from 'classnames';
import { ConnectedPaxHeader } from './FragmentHeader/PaxHeader';
import { Fragment } from './Fragment';
import { FragmentBody } from './FragmentBody';
import { ConnectedPaxSelectorContent } from '../../PaxSelector';
import { CMS, ABUtils, withPageContext } from '../../../utils';
import { NextButton } from './NextButton';
import { FlightClassSelector } from '../../FlightClassSelector/FlightClassSelectorMobile';
import { SlideType, TripTypeProp } from '../../../models';
import { SlideGroupContext } from '../../../components/SlideManager';
import { FieldHeaderPrisma } from './FragmentHeader';
import { ButtonCTA } from './ButtonCTA';
import { isTrainsProductActive } from '../../../redux/currentSearch/selectors';


export const PaxFragment = ({ isHotelOptionEnabled, tripType }) => {
    const [showButtonCTA, setShowButtonCTA] = useState(false);
    const { isOpenedWithEmptyFields, getCurrent } = useContext(SlideGroupContext);
    const { isCssVariationMobile, isReduceSearchFlow } = ABUtils.getABs();
    const currentSlideGroup = getCurrent();
    const isDone = currentSlideGroup.history.indexOf(SlideType.PAX) > -1 || !isOpenedWithEmptyFields;
    const paxClassNames = classnames({
        'odf-space-inner-bottom-m': true,
        'prisma-responsive-space-horizontal': isCssVariationMobile,
    });
    const separatorClassNames = classnames({
        'odf-separator-large': isCssVariationMobile,
        'odf-stroke-primary odf-space-outer-bottom-m': !isCssVariationMobile,
    });

    const onEntering = () => {
        if (isReduceSearchFlow) {
            const hasEmptySlides = Array.from(currentSlideGroup.slides.values()).some((slide) => slide.isEmpty);
            setShowButtonCTA(!hasEmptySlides);
        }
    };
    const isTrainsProduct = useSelector((state) => isTrainsProductActive(state));
    return (
        <Fragment
            id={SlideType.PAX}
            isDone={isDone}
            isEmpty={false}
            setValue={() => {}}
            onEntered={onEntering}
        >
            {() => (
                <>
                    {!isCssVariationMobile && (
                        <ConnectedPaxHeader />
                    )}
                    {isCssVariationMobile && (
                        <FieldHeaderPrisma
                            textKey="flightsManager.selection.pax.title"
                        />
                    )}
                    <FragmentBody padding={!isCssVariationMobile}>
                        {!isCssVariationMobile && (
                            <div className="odf-text-soft odf-text-left odf-text-xl odf-space-outer-bottom-m">
                                <CMS id="flightsManager.selection.pax.title" />
                            </div>
                        )}
                        <div className={paxClassNames}>
                            <ConnectedPaxSelectorContent />
                        </div>
                        <div className={separatorClassNames} />
                        {isCssVariationMobile && (
                            <div className="odf-separator-large" />
                        )}
                        {!isTrainsProduct && <FlightClassSelector />}
                    </FragmentBody>
                    { showButtonCTA && (
                        <div className="prisma-elevation-1 odf-space-inner-bottom-m
                            prisma-responsive-space-horizontal safari-extra-padding-bottom-lg"
                        >
                            <ButtonCTA
                                isHotelOptionEnabled={isHotelOptionEnabled}
                                isSearchFragmentPage
                                tripType={tripType}
                                buttonWrapperClassNames={'odf-space-outer-top-m'}
                                secondaryButtonClassNames={'odf-space-outer-top-s'}
                                position='from-pax-'
                            />
                        </div>
                    )}
                    { !showButtonCTA && (
                        <NextButton testId="pax-next-btn" />
                    )}
                </>
            )}
        </Fragment>
    );
};

PaxFragment.propTypes = {
    isHotelOptionEnabled: PropTypes.bool,
    tripType: TripTypeProp.isRequired,
};

PaxFragment.defaultProps = {
    isHotelOptionEnabled: true,
};


const mapStateToProps = ({ currentSearch }) => ({
    tripType: currentSearch.tripType,
});

export const ConnectedPaxFragment = connect(mapStateToProps, {})(withPageContext(PaxFragment));
